export const CONTACT_BLOCK_UPDATE = 'ContactBlockUpdate';
export const WATCH_CONTACT_BLOCK_UPDATE = 'WatchContactBlockUpdate';
